<template>
    <div class="faq-container">
        <div class="faq-question" v-on:click="toggle(index)" v-for="(item, index) in contents">
            <div class="faq-description">{{item.title}} <template v-if="item.situacao">({{item.situacao}})</template></div>
            <div class="faq-content" style="display: none;">
                <p>{{item.msg1}}</p>
                <p>{{item.msg2}}</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'AccordionMenu',
  props: {
    contents: {
      type: Array,
      default: [
        {
          title: 'My Title',
          msg1: 'My msg 1',
          msg2: 'My msg 2',
          situacao: 'Situacao',
        }
      ]
    }
  },
  methods: {
    toggle: function (num) {
      // console.log(this)
      // console.log(this.$el)
      // console.log(this.$el.children)
      if (this.$el.children[num].classList.contains('open')) {
        // console.log("if")
        this.$el.children[num].classList.remove('open')
        this.$el.children[num].querySelectorAll('.faq-content')[0].style.display = 'none'
      } else {
        // console.log("else")
        var prevFaqQuestion = this.$el.querySelectorAll('.open')
        if (prevFaqQuestion.length !== 0) {
          prevFaqQuestion[0].classList.remove('open')
          prevFaqQuestion[0].querySelectorAll('.faq-content')[0].style.display = 'none'
        }
        this.$el.children[num].classList.add('open')
        this.$el.children[num].querySelectorAll('.faq-content')[0].style.display = ''
      }
    },
  },
}
</script>

<style scoped>
.faq-container {
  margin: 0 auto;
}
.faq-question {
  padding: 0px;
  transition: all 0.3s;
}
.faq-description {
  cursor: pointer;
  border-top: 1px solid #d1d3d4;
  position: relative;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  transition: all 0.3s;
}
.faq-description span:last-child {
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  transition: all 0.3s;
  position: absolute;
  font-size: 2em;
}
.faq-question.open {
  background: #f7f7f7;
}
</style>


// WEBPACK FOOTER //
// AccordionMenu.vue?113c5414